var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import postLoginUrl from "@adapters/infrastructures/urlConfig/PostLogin/PostLoginUrl";
import { IndexDetailsMapper } from "@domains/features/PostLogin/mapper/IndexDetailsMapper";
import { NetPositionsMapper } from "@domains/features/PostLogin/mapper/NetPositionsMapper";
import { ILoginAccountTypes } from "@domains/features/LoginFlow/entities/CommonLoginData";
var PostLoginRepository = /** @class */ (function () {
    function PostLoginRepository(http, accountDetails) {
        this.http = http;
        this.accountDetails = accountDetails;
    }
    PostLoginRepository.prototype.getNFOLive = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(postLoginUrl.nfoLive);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    PostLoginRepository.prototype.getNetPositions = function () {
        return __awaiter(this, void 0, void 0, function () {
            var accountType, url, _a, _b, _c, result;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, this.accountDetails.getAccTyp()];
                    case 1:
                        accountType = _d.sent();
                        _a = URL.bind;
                        _b = (accountType === ILoginAccountTypes.CO
                            ? postLoginUrl.positionsCom
                            : postLoginUrl.positions);
                        _c = "/".concat;
                        return [4 /*yield*/, this.accountDetails.getUserID()];
                    case 2:
                        url = new (_a.apply(URL, [void 0, _b + _c.apply("/", [_d.sent()])]))();
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 3:
                        result = _d.sent();
                        return [2 /*return*/, NetPositionsMapper(result)];
                }
            });
        });
    };
    PostLoginRepository.prototype.saveIndicesData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(postLoginUrl.saveIndices);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    PostLoginRepository.prototype.portfolioCompositionData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var accountCode, url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.accountDetails.getAccountCode()];
                    case 1:
                        accountCode = _a.sent();
                        url = new URL(postLoginUrl.portfolioComposition);
                        url.searchParams.append("accountId", accountCode);
                        url.searchParams.append("type", req.type);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    PostLoginRepository.prototype.getContributionData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var accountCode, url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.accountDetails.getAccountCode()];
                    case 1:
                        accountCode = _a.sent();
                        url = new URL(postLoginUrl.contribution);
                        url.searchParams.append("accountId", accountCode);
                        url.searchParams.append("type", req.type);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    PostLoginRepository.prototype.getIndexDetails = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(postLoginUrl.indexList);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, IndexDetailsMapper(result.data)];
                }
            });
        });
    };
    PostLoginRepository.prototype.getMarketMapPL = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, accountCode, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(postLoginUrl.marketMapPostLogin);
                        return [4 /*yield*/, this.accountDetails.getAccountCode()];
                    case 1:
                        accountCode = _a.sent();
                        url.searchParams.append("accountId", accountCode);
                        url.searchParams.append("investmentType", req.investmentType);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    PostLoginRepository.prototype.exploreTrading = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(postLoginUrl.exploreTrade);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    PostLoginRepository.prototype.getServiceList = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(postLoginUrl.serviceList);
                        url.searchParams.append("accTyp", req.accTyp);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    PostLoginRepository.prototype.getDiversifyPortfolio = function () {
        return __awaiter(this, void 0, void 0, function () {
            var accountCode, url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.accountDetails.getAccountCode()];
                    case 1:
                        accountCode = _a.sent();
                        url = new URL(postLoginUrl.diversifyPortfolio);
                        url.searchParams.append("accountId", accountCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    PostLoginRepository.prototype.getAllIndicesList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(postLoginUrl.allIndicesList);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    PostLoginRepository.prototype.getUpcomingEvents = function () {
        return __awaiter(this, void 0, void 0, function () {
            var accountCode, url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.accountDetails.getAccountCode()];
                    case 1:
                        accountCode = _a.sent();
                        url = new URL(postLoginUrl.upcomingEvents);
                        url.searchParams.append("accountId", accountCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    return PostLoginRepository;
}());
export default PostLoginRepository;
